import React from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import { Product } from '@interfaces/models/product';
import { useContextSelector } from 'use-context-selector';
import { ModalContext } from '@context/modal.context';
import SizeGuideWrapper from '@components/atoms/size-guide-wrapper/size-guide-wrapper';
import dynamic from 'next/dynamic';
import styles from './product-characteristics.module.scss';

const ConditionGuideModal = dynamic(
  () => import('@components/molecules/products/product-description/condition-guide-modal/condition-guide-modal'),
  {
    ssr: false,
  },
);

interface ProductCharacteristicsProps {
  product: Product;
}

const ProductCharacteristics: React.FC<ProductCharacteristicsProps> = (props) => {
  const { product } = props;

  const { t } = useTranslation();
  const openModal = useContextSelector(ModalContext, (v) => v.openModal);

  const openConditionGuideModal = () => openModal(<ConditionGuideModal productId={product.id} />);

  return (
    <>
      {product?.size?.size && (
        <p>
          {product.size.size}
          {product.size.localizedStandard && <span>{` ${product.size.localizedStandard}`}</span>}
          <SizeGuideWrapper
            universeId={product.universe.id}
            productCategoryId={product.category.id}
            sizeGuideStandard={product.size.standard}
            sizeGuideSize={product.size.size}
            className={styles.moreInfoLink}
          >
            {t('PRODUCT.DETAILS.SIZES_GUIDE')}
          </SizeGuideWrapper>
        </p>
      )}
      {product?.condition?.description && (
        <p>
          <span>{product?.condition.description}</span>
          <Button
            disableDefaultStyling
            type="submit"
            className={styles.moreInfoLink}
            onClick={openConditionGuideModal}
            data-cy="product-details-view-condition-guide-modal-button"
          >
            {t('PRODUCT.DETAILS.MORE_INFO')}
          </Button>
        </p>
      )}
      {product.color?.localizedName && (
        <p>
          {product?.color?.localizedName}
          <span>, </span>
          {product.material?.parent?.localizedName ? (
            <span>{product.material.parent.localizedName}</span>
          ) : (
            <span>{product?.material?.localizedName}</span>
          )}
        </p>
      )}
    </>
  );
};

export default ProductCharacteristics;
